// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 11/27/2023 3:13:30 PM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

export enum FieldTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  wage = 2,
  additionalIncome = 3,
  deduction = 4,
  wageHours = 5,
  hourlyRate = 6,
  microDeposit = 7,
  benefit = 8,
  contractorSalesTax = 9,
  tax = 10,
  additionalIncomeHours = 11,
  vacationAccrue = 12,
}

export enum AttributeTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  incomeTax = 2,
  cppQpp = 3,
  ei = 4,
  qpop = 5,
  insurableHours = 6,
  insurableEarnings = 7,
  socialSecurity = 8,
  medicare = 9,
  taxable = 10,
}

export enum SectionTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  contribution = 2,
  roe = 3,
  t4 = 4,
  rl1 = 5,
  w2 = 6,
}

export enum ContributionTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  employee = 2,
  employer = 3,
}

export enum ContributionColumnTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  federal = 2,
  quebec = 3,
}

export enum FieldSubTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  aggregate = 2,
  garnishment = 3,
  incomeExpenseReimbursement = 4,
  controlledTips = 5,
  periodicPayments = 6,
  reduceTaxableIncome = 7,
}

export enum TaxImplicationTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  preTax = 2,
  postTax = 3,
}

export enum CountryTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  uS = 2,
  cA = 3,
}

export enum ValidationActionTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  info = 2,
  warning = 3,
  error = 4,
}

export enum PayPeriodActionTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  info = 2,
  warning = 3,
  error = 4,
}

export enum CalulationType {
  notDefined = 0,
  notSpecified = 1,
  multiplication = 2,
  addition = 3,
}

export enum TaxTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  federal = 2,
  empInsurance = 3,
  pension = 4,
  additional = 5,
  state = 6,
  local = 7,
  medical = 8,
  workmansComp = 9,
  salesTax = 10,
  employerHealthTax = 11,
  healthServicesFund = 12,
  heLevy = 13,
  hapset = 14,
  parentalInsurance = 15,
  registgerRetirementSavingsPlan = 16,
  stateHealthEducationTax = 17,
}

export enum TaxFlagsEnum {
  none = 0,
  insurable = 1,
  pensionable = 2,
  taxable = 4,
  unemployment = 4,
}

export enum PeriodFlags {
  none = 0,
  monthPeriod1 = 1,
  monthPeriod2 = 2,
  monthPeriod3 = 4,
  monthPeriod4 = 8,
  monthPeriod5 = 16,
}

export enum ExplicitFieldTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  grossPay = 2,
  netPay = 3,
  regularHours = 4,
  regularPay = 5,
  regularRate = 6,
  otHours = 7,
  otPay = 8,
  workmansComp = 9,
  workmansCompRate = 10,
  totalWageHours = 11,
  totalAdditionalIncomes = 12,
  holidayPay = 13,
  vacationPay = 14,
  statPay = 15,
  workedOnStatPay = 16,
  sickPay = 17,
  doubleOvertimePay = 18,
  totalDeductions = 19,
  totalBenefits = 20,
  vacationAccrued = 21,
  contractorPay = 22,
  unionDues = 23,
  parentalInsurance = 24,
  charitableDonation = 25,
  totalWage = 26,
  fedLaborFundsTaxCredit = 27,
  vacationPayPaidOut = 28,
  totalAdditionalHours = 29,
}

export enum FieldAccountLedgerTypeEnum {
  notDefined = 0,
  payPeriod = 1,
  reversed = 2,
  prior = 3,
  adjustment = 4,
  payPeriodReversal = 5,
}

export enum StateCalculationFlagsEnum {
  none = 0,
  vacationPay = 1,
  workmansCompensation = 2,
  statutoryPay = 4,
  employerHealthTax = 8,
  healthServicesFund = 16,
  pensionPlan = 32,
  parentalInsurancePlan = 64,
  provincialIncomeTax = 128,
  stateEducationTax = 256,
  bonusTax = 512,
  vacationOnVacationAccrue = 1024,
  vacationOnVacationPaidOut = 2048,
  vacationOnVacationAccrueOnTerminate = 4096,
  vacationOnVacationPaidOutOnTerminate = 8192,
}

export enum FieldStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  dataEntryInProgress = 2,
  pendingApproval = 3,
  active = 4,
  rejected = 5,
  deleted = 6,
}

export enum LocalTaxFlags {
  none = 0,
  gross = 1,
  include401K = 2,
}

export enum ContributionEntryTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  amount = 2,
  percent = 3,
  amountOrPercent = 4,
}

export enum FieldOriginTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  original = 2,
  duplicate = 3,
  edit = 4,
  custom = 5,
}

export enum AccountTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  cash = 2,
  payable = 3,
  revenue = 4,
  expense = 5,
  receivable = 6,
  liability = 7,
}

export enum ExplicitAccountTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  cashProcessing = 2,
  cashCorporate = 3,
  processingFeesClearing = 4,
  salesTaxClearing = 5,
  workersCompClearing = 6,
  processingFeesExpenses = 7,
  salesTaxExpenses = 8,
  vacationAccrued = 9,
  vacationPayingOut = 10,
  expenseReimbursement = 11,
  netPay = 12,
  vacationPayable = 13,
  controlledTips = 14,
  wagepointFees = 15,
  salesTax = 16,
  accountsPayable = 17,
  sourceExpense = 18,
  sourcePayable = 19,
  hapSet = 20,
  wcb = 21,
  eht = 22,
  deductions = 23,
  payrollTaxExpense = 24,
}

export enum AccountDisplayCategoryTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  bank = 2,
  clearing = 3,
  wagesEarningExpenses = 4,
  benefitExpenses = 5,
  taxExpenses = 6,
  taxLiabilities = 7,
  benefitLiabilities = 8,
  wagesEarningLiabilities = 9,
  subscriptionFees = 10,
  deductionLiabilities = 11,
}

export enum DefaultAccountTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  wage = 2,
  income = 3,
  benefit = 4,
}

export enum AccountSubTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  netPay = 2,
  payrollExpense = 3,
  wageExpense = 4,
  sourceExpense = 5,
  sourcePayable = 6,
  accountsPayable = 7,
  controlledTips = 8,
  prepaidAsset = 9,
  vacationPayable = 10,
  salesTax = 11,
}

export enum PostingJournalTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  incomePayable = 2,
  incomeNotPayable = 3,
  incomeVacationAccrued = 4,
  incomeVacationPayingOut = 5,
  incomeExpenseReimbursement = 6,
  incomeControlledTips = 7,
  otherPayrollRelated = 8,
  sourceDeduction = 9,
  stateWiseSourceDeduction = 10,
  deduction = 11,
  invoiceWagepointFees = 12,
  invoiceWagepointSalesTax = 13,
  benefit = 14,
}

export enum RemittanceTypeEnum {
  notDefined = 0,
  notSpecified = 1,
}

export enum JournalMapTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  wagesAndEarningsExpenses = 2,
  wagesAndEarningsLiabilities = 3,
  employeeBenefitExpenses = 4,
  employeeBenefitLiabilities = 5,
  payrollTaxLiabilities = 6,
  payrollTaxExpenses = 7,
  payrollClearing = 8,
  deductionLiabilities = 9,
  payrollSubscriptionFees = 10,
  payrollBankAccount = 11,
}

export enum JournalMapSubTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  processingFeesClearing = 2,
  salesTaxClearing = 3,
  workersCompClearing = 4,
  netPayManual = 5,
  controlledTips = 6,
  vacationAccrued = 7,
  processFeesExpenses = 8,
  salesTaxExpenses = 9,
  cppQppExpense = 10,
  qpipExpense = 11,
  employerHealthTaxExpense = 12,
  cppQppPayable = 13,
  qpipPayable = 14,
  eiPayable = 15,
}

export enum FieldBoxIncludeFlags {
  none = 0,
  includedIn17c = 1,
  includedIn15bAndC = 2,
  includedIn19b = 4,
}

export enum JournalIntegrationStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  dormant = 2,
  waitingToBeSynchronized = 3,
  synchronized = 4,
  waitingToBePlacedOnBankFile = 5,
}

export enum OtherMonieValidationActionTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  optional = 2,
  mandatory = 3,
  mustBeBlank = 4,
}

export enum AdjustmentStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  created = 2,
  waitingApproval = 3,
  posted = 4,
}

export enum AdjustmentTypeEnum {
  notDefined = 0,
  payPeriod = 1,
  yearToDate = 2,
}

export enum MoneyFileTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  bankWithdrawalTax = 2,
  bankWithdrawalNetpay = 3,
  bankDeposit = 4,
  bankWithdrawalFee = 5,
  bankDepositSource = 6,
  bankMicroDeposit = 7,
}

export enum AccountExplicitTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  cashNet = 2,
  cashTax = 3,
  cashFee = 4,
  escrowFunds = 5,
  taxGstCollected = 6,
  taxPstCollectedBc = 7,
  taxPstCollectedMan = 8,
  taxPayableSuspense = 9,
  cogsMicoDeposit = 10,
  depositReversalPending = 11,
  receivableWireFunds = 12,
  receivableNsfFundsNet = 13,
  receivableNsfFundsTax = 14,
  receivableNsfFundsFee = 15,
  payableRejectedTaxDeposits = 16,
  payableRejectedNetPayDeposits = 17,
  payableNetPay = 18,
  payableTaxCra = 19,
  payableTaxRq = 20,
  payableTaxWcbSuspense = 21,
  payableTaxWcbBc = 22,
  payableTaxWcbAb = 23,
  payableTaxWcbSask = 24,
  payableTaxWcbMan = 25,
  payableTaxWcbOnt = 26,
  payableTaxWcbNs = 27,
  payableTaxWcbPei = 28,
  payableTaxEhtOn = 29,
  feeNsfSubscription = 30,
  feeBlockedAccount = 31,
  feeRoe = 32,
  feeYearEndAdjustment = 33,
  feeCreditError = 34,
  feeOtherPayable = 35,
  feeOtherReceivable = 36,
  feeService = 37,
  feeNsfNet = 38,
  feeNsfTax = 39,
  feeRejectedNet = 40,
  feeRejectedTax = 41,
  feeWireFunds = 42,
  taxCreditRemittanceAdjustment = 43,
  taxCreditWithdrawalAdjustment = 44,
  customDiscountPartnerBase = 45,
  customDiscountPartnerPerson = 46,
  customDiscountCustomerBase = 47,
  customDiscountCustomerPerson = 48,
}

export enum JournalEntryPurposeTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  payroll = 2,
  payrollReverse = 3,
  payrollChangeToNoMoneyMovement = 4,
  payrollChangeToNoMoneyMovementTax = 5,
  payrollChangeToNoMoneyMovementNet = 6,
  f1_CollectionNetPay = 7,
  f2_CollectionTax = 8,
  f3_DepositNetPay = 9,
  f4_DepositTaxRq = 10,
  f5_DepositTaxCra = 11,
  f6_DepositTaxOn = 12,
  f7_DepositTaxWcb = 13,
  f8_WireTransferClient = 14,
  f9_WireTransferReceived = 15,
  f10_DepsitStopped = 16,
  f11_DepositNetPayCredit = 17,
  f12_DepositTaxesCredit = 18,
  f13_No_Longer_Used = 19,
  f14_ClientChangesMethod = 20,
  f15_NsfNetReported = 21,
  f16_NetNsfPayManually = 22,
  f17_NetNsfIncomingReceived = 23,
  f18_RecordingDepositReversal = 24,
  f19_ResolveSuccessfulDepositReversal = 25,
  f20_ResolveUnsuccessfulDepositReversal = 26,
  f21_NsfTaxReported = 27,
  f22_NsfTaxClientResolveByRemitting = 28,
  f23_NsfTaxIncomingReceived = 29,
  f24_NetPayRejectedDeposit = 30,
  f25_NetPayRejectedResubmit = 31,
  f26_NetPayRejectedDepositCanceled = 32,
  f27_TaxRejectedDeposit = 33,
  f28_TaxRejectedDepositResubmit = 34,
  f29_NetPayRejectedCancelled = 35,
  f30_MicroDeposit = 36,
  f31_CollectionProcessingFees = 37,
  f32_NsfProcessingFeesReported = 38,
  f33_NsfProcessingFeesIncoming = 39,
  f34_ChargeNextInvoice = 40,
  f35_TaxAgencyNotifysTaxOverpayment = 41,
  f36_NetPayAchToWire = 42,
  f37_TaxAchToWire = 43,
  f38_NetPayAchToNoMoneyMovement = 44,
  f39_TaxAchToNoMoneyMovement = 45,
  f40_NetPayAchToWireIncoming = 46,
  f41_TaxAchToWireIncoming = 47,
  f42_StopDepositNetPay = 48,
  f43_StopDepositTax = 49,
  f44_RemovePersonFromPayroll = 50,
  f45_NetPayIncomingFromMissOrCs = 51,
  f46_TaxIncomingFromMissOrCs = 52,
  f47_NetPayFromMissOrCs = 53,
  f48_TaxFromMissOrCs = 54,
  f49_FeesCreditNextInvoice = 55,
  f50_TaxCreditApplied = 56,
  f51_TaxCreditCancelled = 57,
  f52_TaxCreditCreated = 58,
}

export enum InvoiceTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  payroll = 2,
  fee = 3,
  creditInvoice = 4,
}

export enum InvoiceItemTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  monthlyFee = 2,
  personFee = 3,
  nsfFee = 4,
  customerDiscount = 5,
  partnerDiscount = 6,
  salesTax = 7,
  billAdjustmentCharge = 8,
  billAdjustmentCredit = 9,
  taxCredit = 10,
  rejection = 11,
}

export enum TaxAccountUpdateMethodTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  creditTransferedToNewAccount = 2,
  newCreditAccount = 3,
  doNotTransfer = 4,
  pending = 5,
}

export enum TaxCreditStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  active = 2,
  closed = 3,
}

export enum AdjustmentPaymentTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  over = 2,
  under = 3,
}

export enum InvoiceRunStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  running = 2,
  completed = 3,
  nextUp = 4,
}

export enum InvoiceRunTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  customer = 2,
  client = 3,
  partner = 4,
  nsf = 5,
}

export enum InvoiceRunErrorStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  inError = 2,
  fixed = 3,
}

export enum InvoiceRunErrorTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  invoice = 2,
  journalEntry = 3,
  collectionBankTx = 4,
}

export enum InvoiceRunPartnerStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  notStarted = 2,
  running = 3,
  completed = 4,
}

export enum TaxMethodTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  collectDirectly = 2,
  applyAsCredit = 3,
}

export enum InvoiceStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  paid = 2,
  unpaid = 3,
  void = 4,
}

export enum InvoiceFeeTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  subscriptionFee = 2,
  nsfFee = 3,
}

export enum InvoiceCreditTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  netPay = 2,
  tax = 3,
}

export enum TaxCreditTransferStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  pending = 2,
  completed = 3,
  deleted = 4,
}

export enum TaxCreditTransferTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  transferToNewAccount = 2,
  doNotTransferToNewAccount = 3,
  decideLater = 4,
}

export enum TaxCreditAccountTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  craAccount = 2,
  rqAccount = 3,
  ehtAccount = 4,
  wcbAccount = 5,
}

export enum InvoiceVoidReasonTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  nsfChequePayment = 2,
  nsfManualRemitannce = 3,
  nsfCollectionAmountChanged = 4,
  allEmployeeRemoved = 5,
  collectionNetAmountChanged = 6,
  collectionTaxAmountChanged = 7,
}

export enum RefundSourceTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  stopDeposit = 2,
  removePerson = 3,
  noNetDeposit = 4,
  noTaxDeposit = 5,
  rejectedNetDeposit = 6,
  rejectedTaxDeposit = 7,
}

export enum DiscountSourceTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  partnerTier = 2,
  partnerCustom = 3,
  customerCustom = 4,
}

export enum RunTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  invoice = 2,
  expireTrialRollOver = 3,
  expireTrialClose = 4,
  expireTrialBanner = 5,
  close = 6,
  customerInvoice = 7,
  clientInvoice = 8,
  partnerInvoice = 9,
  nsfInvoice = 10,
  workflowInvocation = 11,
  inSuspense = 12,
}

export enum InvoiceItemOwnerTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  client = 2,
  partner = 3,
}

export enum BankAccountTypeEnum {
  notDefined = 0,
  businessChecking = 1,
  personalChecking = 2,
  personalSavings = 3,
}

export enum PriorityTypeEnum {
  notDefined = 0,
  first = 1,
  second = 2,
  third = 3,
  fourth = 4,
}

export enum BankAccountStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  inactive = 2,
  notSubmitted = 3,
  pending = 4,
  approved = 5,
  rejected = 6,
  additionalDocumentsRequested = 7,
  submissionRevoked = 8,
}

export enum MicroDepositStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  waitingMicroDeposit = 2,
  microDepositPosted = 3,
  microDepositVerified = 4,
  microDepositLocked = 5,
  microDepositRejected = 6,
}

export enum AgreementTypeEnum {
  notDefined = 0,
  natPay = 1,
  preAuthorizationDebit = 2,
  accountValidationRequest = 3,
  preAuthorizationDebitConfirmation = 4,
}

export enum YodleeVerificationStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  waitingYodleeVerification = 2,
  yodleeVerified = 3,
  yodleeVerificationFailed = 4,
}

export enum BankTransactionTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  collectionsNetPay = 2,
  collectionsTax = 3,
  collectionsFee = 4,
  depositsNetPay = 5,
  depositsTax = 6,
  depositsNetPayCredit = 7,
  depositsMicro = 8,
  depositsTaxCredit = 9,
  depositsRejectedNetPay = 10,
  depositsRejectedTax = 11,
  depositsSalesTaxCredit = 12,
  depositTaxPayPeriod = 13,
}

export enum BankAccountAuthorizationTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  pending = 2,
  rejected = 3,
  verified = 4,
  inProgress = 5,
}

export enum BankFileStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  preview = 2,
  waitingToBeSent = 3,
  sent = 4,
}

export enum BankTransactionStatusTypeEnum {
  notDefined = 0,
  dateDependentEligible = 1,
  placedOnBankFile = 2,
  ineligible = 3,
  reversalSuccess = 4,
  waitingReceived = 5,
  received = 6,
  paused = 7,
  suspended = 8,
  clearedManually = 9,
}

export enum WithdrawalStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  nsf = 2,
  nsfTransfer = 3,
  nsfCleared = 4,
  nsfReversal = 5,
  nsfClearedByCredit = 6,
  rejected = 7,
  rejectedReattempt = 8,
  rejectedCreditDue = 9,
}

export enum CollectionTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  manualCheck = 2,
  electronicTransfer = 3,
  wire = 4,
  automaticClearingHouse = 5,
}

export enum DepositStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  stopped = 2,
  rejected = 3,
  rejectedReattempt = 4,
  rejectedCreditDue = 5,
  rejectedArchived = 6,
  removedFromPayroll = 7,
  creditClearedByNsf = 8,
}

export enum RiskProfileTypeEnum {
  notDefined = 0,
  low = 1,
  medium = 2,
  high = 3,
}

export enum PreAuthorizationDebitSignStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  pending = 2,
  completed = 3,
  requiresNewSign = 4,
}

export enum BankAccountVerificationTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  instant = 2,
  manual = 3,
}

export enum PlaidVerificationStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  waitingPlaidVerification = 2,
  plaidVerified = 3,
  plaidVerificationFailed = 4,
}

export enum RiskComplianceStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  notSubmitted = 2,
  pending = 3,
  approved = 4,
  rejected = 5,
}

export enum SignatoryNameVerificationStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  pending = 2,
  nameMatches = 3,
  nameDoesNotMatch = 4,
}

export enum TaxAgencyTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  cra = 2,
  rq = 3,
  eht = 4,
  wcb = 5,
}

export enum BankTransactionBillingStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  waitingBillCreation = 2,
  billed = 3,
}

export enum BankTransactionFeeTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  nsf = 2,
  rejection = 3,
  stopDeposit = 4,
  transfer = 5,
}

export enum RejectionResolveMethodTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  payByCheck = 2,
  bankAccountUpdate = 3,
  differentBankAccount = 4,
  creditIssued = 5,
  resolvedTaxManually = 6,
}

export enum NsfResolvedTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  credits = 2,
  manualRemittance = 3,
  manualCheck = 4,
  fundTransfer = 5,
}

export enum BankReversalStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  pending = 2,
  successful = 3,
  unsuccessful = 4,
}

export enum BillingFeeStatusTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  waitingBilling = 2,
  hasBeenBilled = 3,
}

export enum IncomingPaymentPurposeTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  collectionMethodChange = 2,
  deadlineMiss = 3,
  nsf = 4,
}

export enum SalesTaxTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  caGst = 2,
  caHst = 3,
  caPst = 4,
}

export enum SubscriptionPeriodAuditTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  clientPaysFees = 2,
  partnerPaysFees = 3,
  switchToPartnerPays = 4,
  switchToClientPays = 5,
  clientDisconnected = 6,
  clientChangedPlan = 7,
  accountClosed = 8,
  trialAccountRestored = 9,
  accountReactivated = 10,
  partnerDisconnected = 11,
  partnerConnected = 12,
  trialRolledOver = 13,
  trialSkipped = 14,
  accountRestored = 15,
}

export enum CompanyLinkTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  clientToPartner = 2,
  partnerToClient = 3,
  partnerToParentPartner = 4,
  partnerToChildPartner = 5,
  parentToChildCompany = 6,
  childToParentCompany = 7,
}

export enum SuspensionResolveTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  removeSuspension = 2,
  reattemptManually = 3,
}

export enum CloseAccountUiLinkTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  roe = 2,
  ytd = 3,
  reports = 4,
}

export enum BankAccountPurposeFlagsEnum {
  none = 0,
  company = 1,
  partner = 2,
}

export enum TaxDetailUsageTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  collectionTax = 2,
  depositTax = 3,
  payPeriod = 4,
}

export enum AlfredCompanyStatusTypeEnum {
  notDefined = 0,
  active = 1,
  inActive = 2,
  closed = 3,
}

export enum FeatureTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  multiplePayrolls = 2,
  oneActivePaygroup = 3,
  payGroupMonthlyFrequencyOnly = 4,
  cantRunOffCyclePayrolls = 5,
  onePayrollPerMonth = 6,
}

export interface FieldInterface {
  id: number;
  companyId: number;
  revision: number;
  revisionKey: number;
  name: string;
  glAccount: string;
  ytdMax: string;
  validationActionTypeId: number;
  payPeriodMin?: number;
  payPeriodMax?: number;
  payPeriodVariance?: number;
  payPeriodActionTypeId: number;
  rateCoefficient?: number;
  periodFlags: number;
  code: string;
  description: string;
  formula: string;
  associationKey?: string;
  sortOrder: number;
  formBoxListJson: string;
  insurableHours: boolean;
  insurableEarnings: boolean;
  fieldNote: string;
  fieldStatusTypeId: number;
  includedIn17c: boolean;
  includedIn15BandC: boolean;
  accountId?: number;
  fieldOriginTypeId: number;
  baseFieldExplicitFieldTypeId: number;
  baseFieldFieldTypeId: number;
  baseFieldFieldSubTypeId: number;
  baseFieldContributionTypeId: number;
  baseFieldContributionPartnerBaseFieldId?: number;
  baseFieldId: number;
  baseFieldIsPayable: boolean;
  baseFieldTaxAgencyId?: number;
}

export interface FieldAccountLedgerInterface {
  id: number;
  amount: number;
  payPeriodRowPk: string;
  payPeriodRowRk: string;
  periodNumber: number;
  periodMonth: number;
  payPeriodId: number;
  fieldAccountId: number;
  fieldAccountLedgerStateTypeId: number;
  ledgerId: number;
}

export interface BaseFieldInterface {
  id: number;
  countryTypeId: number;
  rootBaseFieldId: number;
  fieldTypeId: number;
  fieldSubTypeId: number;
  explicitFieldTypeId: number;
  contributionTypeId: number;
  contributionPartnerBaseFieldId: number;
  calculationPartnerBaseFieldId: number;
  isFixed: boolean;
  taxName: string;
  isPayable: string;
  taxFlags: string;
  taxTypeId: number;
  taxMaxDeduction: string;
  taxMaxDeductionOverAge: string;
  taxMaxAppliesToAgeAndOver: string;
  revision: number;
  fieldRevision: number;
  fieldId: number;
  stateConernListJson: string;
  localConernListJson: string;
}

export interface InvoiceItemInterface {
  id: number;
  discount: number;
  amount: number;
  description: string;
  memo: string;
  stateId?: number;
  ruleNumber: number;
  fieldId?: number;
  isAdjustmentCredit: boolean;
  refundSourceTypeName: string;
  refundSourceItemId?: number;
  employeeId?: number;
  taxAgencyId?: number;
}

export interface InvoiceInterface {
  id: number;
  companyId: number;
  isDeleted: boolean;
  payPeriodId?: number;
  invoiceDate: string;
  isCredit: boolean;
  subscriptionMonth: number;
  subscriptionYear: number;
  invoiceVoidReasonTypeName: string;
  invoiceItemList: Array<InvoiceItemInterface>;
}

export interface StateConcernInterface {
  id: number;
  stateId?: number;
  coversUnspecifiedStates: boolean;
  stateCalculationFlags: number;
  taxFlags: number;
  taxInclusionIds: string;
  taxFlagsOverride: boolean;
  stateSpecificName: string;
  baseFieldId: number;
}

export interface EmployeeBankAccountInterface {
  id: number;
  transitNumber: string;
  iban: string;
  accountNumber: string;
  correlationKey?: string;
  revision: number;
  verificationDate?: string;
  verificationAttemptCount: number;
  verificationDepositAmount: number;
  clientSubmitDate?: string;
  bankAccountTypeId: number;
  bankAccountStatusTypeId: number;
  bankName: string;
  institutionNumber: string;
  microDepositStatusTypeId: number;
  plaidVerificationStatusTypeId: number;
  bankAccountAuthorizationTypeId: number;
  personId: number;
  appliedPercent: number;
  appliedAmount: number;
  priority: number;
}

export interface CompanyBankAccountInterface {
  id: number;
  transitNumber: string;
  iban: string;
  accountNumber: string;
  correlationKey?: string;
  revision: number;
  verificationDate?: string;
  verificationAttemptCount: number;
  verificationDepositAmount: number;
  clientSubmitDate?: string;
  bankAccountTypeId: number;
  bankAccountStatusTypeId: number;
  bankName: string;
  institutionNumber: string;
  microDepositStatusTypeId: number;
  plaidVerificationStatusTypeId: number;
  bankAccountAuthorizationTypeId: number;
  companyId: number;
  signatory: string;
  confirmedBusinessAccount: boolean;
  confirmedPreAuthDebit: boolean;
  signatoryId?: number;
  bankAccountVerificationTypeId: number;
}

export interface BankTransactionInterface {
  id: number;
  payPeriodId: number;
  amount: number;
  isDeposit: boolean;
  fieldAccountLedgerId: number;
  bankTransactionTypeId: number;
  bankId: number;
  bankName: string;
  accountNumber: string;
  personId: number;
  onBehalfCompanyId?: number;
  remittanceFrequencyId?: number;
  bankTransactionStatusTypeId: number;
  withdrawalStatusTypeId: number;
  depositStatusTypeId: number;
  moneyCanBeMovedDate: string;
  formattedRow: string;
  transferAdminName: string;
  collectionTypeId: number;
  documentId?: number;
  companyId: number;
  bankAccountRevision: number;
  nsfFee?: number;
  rejectionFee?: number;
  institutionNumber: string;
  remittancePeriodStartDate?: string;
  remittancePeriodEndDate?: string;
  taxAgencyId?: number;
  taxAccountNumber: string;
  transitNumber: string;
}

export interface BankAgreementInterface {
  formId: number;
  formStatusTypeId: number;
  documentId?: number;
  isDigitallySigned: boolean;
  signatureDate?: string;
  agreementTypeId: number;
  legacyName: string;
  legacyPath: string;
  legacyTags: string;
  legacyCorrelationKey?: string;
}

export interface PlaidVerificationInterface {
  companyBankAccountId?: number;
  accountName: string;
  accountType: string;
  accountSubType: string;
  accountNumber: string;
  branchNumber: string;
  routingNumber: string;
  bankName: string;
  currentBalance: number;
  balanceReportedDate?: string;
  isVerified: boolean;
  verifiedDate?: string;
  transactionId: string;
  realmId: string;
  accessToken: string;
  availableBalance: number;
  accountId: string;
  assetReportId: string;
  assetReportToken: string;
  assetReportDocumentId: number;
  jsonDocumentId: number;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

export enum PartnerInvoiceItemTypeEnum {
  notDefined = 0,
  notSpecified = 1,
  main = 2,
  nsfFee = 3,
  rejectedFee = 4,
  credit = 5,
  charge = 6,
}
